<template>
  <div class="container pt-md-5 py-3">
    <loading :active.sync="isLoading"></loading>
    <h1 class="mb-5 font-weight-bolder">社團公告</h1>

    <div class="row align-items-start mb-4">
      <div class="col-md-3 col-6">
        <div class="form-group">
          <label class="sr-only" for="categoryFilter">分類</label>
          <select class="form-control" id="categoryFilter"
            v-model="categorySelected"
            @change="gaTrackEvent('Club Announcement', 'Filter - Category', categorySelected)">
            <option value="all">分類 - 全部</option>
            <option
              :value="chapter.name"
              v-for="chapter in checkItemActive(chapterList)"
              :key="chapter.id"
            >{{ chapter.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3 col-6">
        <div class="form-group">
          <label class="sr-only" for="sort">排序</label>
          <select class="form-control" id="sort"
            v-model="sortSelected"
            @change="gaTrackEvent('Club Announcement', 'Filter - Sorting', sortSelected)">
            <option value="new">由新到舊</option>
            <option value="pass">由舊到新</option>
            <option value="reply_count">留言數最多</option>
            <option value="view_count">瀏覽數最多</option>
          </select>
        </div>
      </div>
      <div class="col-md-5 ml-auto">
        <div class="input-group position-relative bg-white" style="z-index: 3;">
          <input type="text" class="form-control border-right-0"
            placeholder="搜尋" aria-label="搜尋" aria-describedby="search"
            v-model="searchText" @keypress.enter="search(searchText)">
          <div class="input-group-append">
            <button class="btn btn-outline-light"type="button" id="search"
              @click="search(searchText)">
              <span class="material-icons align-bottom text-dark"> search </span>
            </button>
          </div>
        </div>
        <div class="list-group border-top-0 position-absolute rounded-0"
          v-show="searchIsOpen" style="z-index: 2; left: 15px; right: 15px; top: calc(100% - 2px);">
          <a href="#" class="list-group-item list-group-item-action"
            v-for="post in searchPosts" :key="post.id"
            @click.prevent="setResult(post.name)">{{ post.name }}</a>
        </div>
      </div>
    </div>

    <div v-if="checkSearchResults.length > 0">
      <p>找到 {{ checkSearchResults.length }} 筆符合的單元</p>
      <post-has-tag
        v-for="post in checkSearchResults"
        :key="post.id"
        :data="post.data"
        :url="`/community/chapter/${post.data.chapter.path_var}/post/${post.data.path_var}`"
        :isStar="post.highlight"
        :tag="post.data.chapter.name"
      />
    </div>
    <div v-else>
      <post-has-tag
        v-for="post in sortAllPosts.slice(0, pageInfo.perPage * pageInfo.nowPage)"
        :key="post.id"
        :data="post"
        :url="`/community/chapter/${post.chapterID}/post/${post.path_var}`"
        :isStar="post.highlight"
        :tag="post.chapterName"
      />
      <frontend-pagination btn-text="更多公告"
        :post-data-length="sortAllPosts.length"
        @per-page="perPageData"
        @more-page="morePageData">
      </frontend-pagination>
      <!-- <div class="mt-3 d-flex justify-content-center">
        <a href="#" class="btn btn-lg btn-outline-primary w-75">更多單元</a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Community',
  data() {
    return {
      categorySelected: 'all',
      sortSelected: 'new',
      isLoading: false,
      postList: [],
      communityList: [],
      chapterList: [],
      searchText: '', // 搜尋
      searchResults: [], // 搜尋結果
      searchIsOpen: false,
      pageInfo: {
        perPage: 0,
        nowPage: 1,
        totalPages: 1,
      },
    };
  },
  methods: {
    getData() {
      axios
        .get('/api/community')
        .then((res) => {
          this.communityList = res.data.data;
          this.chapterList = res.data.data.chapters;

          if (res.status == 200) {
            this.chapterList.forEach((chapter) => {
              chapter.posts.forEach((post) => {
                this.postList.push({
                  ...post,
                  chapterName: chapter.name,
                  chapterID: chapter.path_var,
                  chapterColor:
                    chapter.options && chapter.options.hasOwnProperty('color')
                      ? chapter.options.color
                      : '#E8EAF6',
                });
              });
            });
            // this.postList.sort(function (a, b) {
            //   return b.highlight - a.highlight;
            // });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filteredChapter(data) {
      const vm = this;
      if (vm.categorySelected == 'all') {
        return data;
      }
      return data.filter((post) => post.chapterName == vm.categorySelected);
    },
    search(search) {
      const vm = this;
      if (search !== '') {
        vm.gaTrackEvent('Club Announcement', 'Search Lesson', '', search); // GA event
        axios.get(`/api/courses/search?content=${search}`).then((res) => {
          vm.searchResults = res.data.data;
          vm.searchIsOpen = false;
        }).catch((err) => {
          flash(`${err} 搜尋結果錯誤`, 'danger');
        });
      } else {
        vm.searchResults = [];
      }
    },
    setResult(text) {
      this.searchText = text;
      this.searchIsOpen = false;
    },
    checkActiveforSearch(item) {
      if (item && item.length > 0) {
        return item.filter((post) => post.data.active);
      }
      return item;
    },
    perPageData(val) {
      this.pageInfo.perPage = val;
    },
    morePageData(val) {
      this.pageInfo.nowPage = val;
    },
  },
  watch: {
    searchText(val) {
      if (val !== '') {
        this.searchIsOpen = true;
      } else {
        this.searchIsOpen = false;
      }
    },
  },
  computed: {
    searchPosts() {
      const vm = this;
      return this.sortAllPosts.filter((ele) => ele.name.indexOf(vm.searchText) !== -1);
    },
    checkSearchResults() {
      const vm = this;
      if (vm.searchResults.length > 0) {
        this.searchResults.forEach((post) => {
          vm.$set(post.data, 'chapterColor', post.data.chapter.options.color);
        });
        return vm.checkActiveforSearch(vm.searchResults).filter((post) => {
          const coursePathVar = post.data.chapter.course.hasOwnProperty('data') ? post.data.chapter.course.data.path_var : post.data.chapter.course.path_var;
          return coursePathVar == 'community';
        });
      }
      return [];
    },
    sortAllPosts() {
      const vm = this;
      const activeData = vm.checkItemActive(vm.postList);
      if (vm.sortSelected == 'new') {
        // 新到舊
        return vm.filteredChapter(activeData).sort((a, b) => {
          const value1 = a.highlight;
          const value2 = b.highlight;
          if (value1 === value2) {
            return b.opened_at.timestamp - a.opened_at.timestamp;
          }
          return value2 - value1;
        });
      } if (vm.sortSelected == 'pass') {
        // 舊到新
        return vm.filteredChapter(activeData).sort((a, b) => {
          const value1 = a.highlight;
          const value2 = b.highlight;
          if (value1 === value2) {
            a.opened_at.timestamp - b.opened_at.timestamp;
          }
          return value2 - value1;
        });
      }
      return vm.filteredChapter(activeData).sort((a, b) => {
        const value1 = a.highlight;
        const value2 = b.highlight;
        if (value1 === value2) {
          b[vm.sortSelected] - a[vm.sortSelected];
        }
        return value2 - value1;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
</style>
